interface InventoryHealthCardProps {
  totalItems?: number;
  lowStockCount?: number;
  outOfStockCount?: number;
  overstockCount?: number;
}

export default function InventoryHealthCard({
  totalItems = 0,
  lowStockCount = 0,
  outOfStockCount = 0,
  overstockCount = 0,
}: InventoryHealthCardProps) {
  const rows = [
    { label: 'Total Active Items', value: totalItems, color: 'text-[#1e293b]', dot: 'bg-slate-400' },
    { label: 'Low Stock Alert Items', value: lowStockCount, color: 'text-amber-600', dot: 'bg-amber-400' },
    { label: 'Out of Stock Items', value: outOfStockCount, color: 'text-red-600', dot: 'bg-red-500' },
    { label: 'Critical Level Items', value: outOfStockCount + (lowStockCount > 0 ? Math.ceil(lowStockCount / 2) : 0), color: 'text-red-700', dot: 'bg-red-700' },
    { label: 'Overstock Items', value: overstockCount, color: 'text-sky-600', dot: 'bg-sky-400' },
  ];

  const totalProblematic = lowStockCount + outOfStockCount;
  const healthScore = totalItems > 0
    ? Math.max(0, Math.round(((totalItems - totalProblematic) / totalItems) * 100))
    : 100;

  return (
    <div className="bg-white border border-[#e2e8f0] rounded-xl p-5">
      <h3 className="text-sm font-semibold text-[#1e293b] mb-4 flex items-center gap-2">
        <i className="ri-store-3-line text-amber-500" />
        Inventory Health
      </h3>

      <div className="space-y-2.5">
        {rows.map((r) => (
          <div key={r.label} className="flex items-center justify-between py-1.5 border-b border-[#f8fafc] last:border-0">
            <div className="flex items-center gap-2">
              <span className={`w-2 h-2 rounded-full ${r.dot} flex-shrink-0`} />
              <span className="text-xs text-[#475569]">{r.label}</span>
            </div>
            <span className={`text-sm font-bold ${r.color}`}>{r.value}</span>
          </div>
        ))}
      </div>

      <div className="mt-3 pt-3 border-t border-[#f1f5f9]">
        <div className="flex items-center justify-between text-xs">
          <span className="text-[#64748b]">Stock health score</span>
          <span className="font-semibold text-emerald-600">
            {healthScore}%
          </span>
        </div>
        <div className="mt-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-emerald-400 rounded-full"
            style={{ width: `${healthScore}%` }}
          />
        </div>
      </div>
    </div>
  );
}
